import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { SsbKonfigService } from '@features/ssb-konfiguration/ssb-konfig.service';
import { Select } from 'primeng/select';
import { Panel } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-ssb-konfig-search',
  imports: [
    FormsModule,
    InputText,
    ReactiveFormsModule,
    Select,
    Panel,
    ButtonModule,
  ],
  templateUrl: './ssb-konfig-search.component.html',
  styleUrl: './ssb-konfig-search.component.css',
})
export class SsbKonfigSearchComponent {
  ssbKonfigService = inject(SsbKonfigService);

  typeOptions = [
    { value: null, label: '[Alle]' },
    { value: 'Opstart', label: 'Opstart' },
    { value: 'BaseEndpoints', label: 'Base endpoints' },
    { value: 'SuffixEndpoints', label: 'Suffix endpoints' },
    { value: 'Konfiguration', label: 'Konfiguration' },
    { value: 'LokalRegnr', label: 'Simulator' },
  ];

  onClickReset() {
    this.ssbKonfigService.resetParams();
  }
}
